"use strict";

(function () {
  // 商品ページ以外は何もしない
  if (!window.location.pathname.includes('/products/')) return;

  console.log("閲覧履歴 保存処理");

  let items = JSON.parse(localStorage.getItem("recentlyViewedProducts")) || [];

  const currentHandle = window.location.pathname
    .split('/products/')[1]
    ?.split('?')[0];

  if (!currentHandle) return;

  // 重複削除
  items = items.filter(item => item.handle !== currentHandle);

  // 追加
  items.push({
    handle: currentHandle,
    timestamp: Date.now()
  });

  // 最大12件
  items = items.slice(-12);

  localStorage.setItem("recentlyViewedProducts", JSON.stringify(items));

  console.log("保存完了", items);
})();